export default {
  index: [
    {
      path: '/dkplan',
      component: resolve => require(['./dkplanIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/dk_plan/_router.js